import echarts from 'echarts';
import fa from 'element-ui/src/locale/lang/fa';
import { config } from '@/views/home/chartJs/chartCommon';

export default function drawBar(params) {
  let { fontColor, fontSize, barMColor, barColorOpacity, barLineBasicColor, tooltip, xAxis, legend } = config;
  let dimensions = ['city'];
  for (let i in params.data[0]) {
    dimensions.push(i);
  }
  let series = [];
  let barC = barMColor,
    barCO = barColorOpacity;
  if (params.barColor && params.barColorOpacity) {
    barC = params.barColor;
    barCO = params.barColorOpacity;
  }
  params?.names.forEach((item, i) => {
    series.push({
      realtimeSort: true,
      type: 'bar',
      name: item,
      barWidth: 3,
      // barGap: 0,//柱间距离
      label: {
        show: params.showLabel,
        position: 'top',
        color: fontColor,
        fontSize,
        fontFamily: 'Geometr706 BlkCn BT',
      },
      itemStyle: {
        normal: {
          show: true,
          color: barC[i],
          // borderWidth: 1,
          // borderColor: barC[i],
        },
      },
      showBackground: true,
      backgroundStyle: {
        color: '#072D4E',
      },
    });
    if (params.isStack) {
      series[i].stack = 'com';
    }
  });

  let option = {
    dataset: {
      dimensions,
      source: params.data,
    },
    // backgroundColor: '#091C3D',
    tooltip: {
      ...tooltip,
      confine: true,
    },
    grid: {
      left: 10,
      top: 8,
      right: 10,
      bottom: 0,
      containLabel: true,
    },
    legend: {
      //图例组件，颜色和名字
      ...legend,
      top: -4,
      show: series.length > 1 ? true : false,
    },

    animationDuration: 0,
    animationDurationUpdate: 200,
    animationEasing: 'linear',
    animationEasingUpdate: 'linear',
    xAxis: {
      type: 'value',
      splitLine: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        textStyle: {
          color: fontColor,
          fontSize,
        },
        interval: 0,
      },
    },
    //  [
    //   {
    //     ...config.yAxis[0],
    //     name: params.yAxis.name,
    //     nameGap: 10,
    //     splitLine: {
    //       show: false,
    //     },
    //   },
    // ],
    yAxis: {
      type: 'category',
      splitLine: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        textStyle: {
          color: fontColor,
          fontSize,
        },
        interval: 0,
      },
      inverse: true,
      animationDuration: 300,
      animationDurationUpdate: 300,
    },
    // xAxis.map((x) => {
    //   x.splitLine.show = false;
    //   return x;
    // }),
    series,
  };
  return option;
}
